/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    SET_CATALOG(state, catalog) {
        state.catalog = catalog
        state.catalogFetchedAt = Date.now()
    },
    SET_CONFIG(state, config) {
        state.config = config
    },
    SET_DASHBOARD(state, dashboard) {
        state.dashboard = dashboard
        state.dashboardFetchedAt = Date.now()
    },
    SET_PERIOD(state, period) {
        state.period = period
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    SET_SAVING(state, saving) {
        state.saving = saving
    },
    SET_ERROR(state, error) {
        state.error = error
    },
    INVALIDATE_DASHBOARD(state) {
        state.dashboard = null
        state.dashboardFetchedAt = null
    },
    INVALIDATE_CATALOG(state) {
        state.catalog = null
        state.catalogFetchedAt = null
    }
}
